import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AttendanceDonwnloadReport } from './Pages';

export const AttendanceDonwnloadReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={AttendanceDonwnloadReport} />
    </Fragment>
)